
import Header from "../components/Header";
import Title3D from "../components/Three.js/Title3D";
import '../styles/Home.css'
import CarrouselServices from "../components/CarrouselServices";
import { Link } from 'react-router-dom';
import TextScrollEffect from '../components/TextScrollEffect';
import Footer from '../components/Footer'
import WaveSeparator from "../components/WaveSeparator";
import WaveSeparatorBlue from "../components/WaveSeparatorBlue";


const Home = () => {
    return(
        <>
        <main>

            <section className="video">
                <div className="telephone__anchorDown">
                    <a className="telephone" href="tel:+33603536593">☎ +33 6 03 53 65 93</a>
                    <a className="anchorDown" href="#title">🡇</a>
                </div>

                <video 
                    src="/Videos/Vidpresentation.mp4"
                    autoPlay
                    muted
                    loop
                    />
                <Title3D className="title3D"/>
            </section>
             <Header />

            <section className="white" id="title">
                <h1>Un chantier naval pour transformer votre bateau.<span> Vivez le large autrement.</span> </h1>
                <WaveSeparator />
            </section>

            <section className="blue" id="presentation">
                <CarrouselServices />
                <Link to="/voyagez" className="buttonToVoyagez">Préparez votre bateau 👉</Link>
                <WaveSeparatorBlue />
            </section>

            <section className="white" id="video__text">
                <TextScrollEffect />
                <WaveSeparator />
            </section>

        </main>
        <Footer />
        </>
    )
}
export default Home;